import { render, staticRenderFns } from "./CreateTypeModal.vue?vue&type=template&id=abc6cab8"
import script from "./CreateTypeModal.vue?vue&type=script&lang=js"
export * from "./CreateTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports